<template>
  <div>
    <a-card style="margin-bottom: 20px">
      <!-- 顶部筛选区域 -->
      <a-row :gutter="[15, 15]" class="row-box">
        <a-col :xl="4" :lg="7" :md="9" :sm="24">
          <j-dict-select-tag
            style="width: 100%"
            placeholder="请选择年级"
            v-model="formData.gradeId"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            :disabled="userIdentity == 2 || userIdentity == 3"
            :isShowEmpty="false"
            @select="(record) => selectTag('grade', record)"
          />
        </a-col>
        <a-col :xl="4" :lg="6" :md="9" :sm="24">
          <j-dict-select-tag
            style="width: 100%"
            placeholder="请选择班级"
            v-model="formData.classId"
            :dictCode="
              'school_class,name,id,grade_id=' + (!formData.gradeId ? -1 : formData.gradeId)
            "
            :async="true"
            :disabled="!formData.gradeId || userIdentity == 3"
            :isShowEmpty="false"
            @select="(record) => selectTag('class', record)"
          />
        </a-col>
        <a-col :xl="4" :lg="6" :md="9" :sm="24">
          <a-range-picker
            :value="lineRangeData"
            :allowClear="false"
            @change="(dates, dateString) => onRangeChange(dates, dateString)"
            style="width: 100%"
          />
        </a-col>

        <a-col :span="2" v-for="(item, index) in searchItem" :key="item" class="tag-col">
          <div class="tag-item" :style="{ borderLeft: `4px solid ${searchItemColor[index]}` }">
            <div class="text">{{ item }}</div>
            <!-- <span class="delete-icon" @click="deleteBtn(item,index)">x</span> -->
            <a-icon class="delete-icon" type="close-circle" @click="deleteBtn(item, index)" />
          </div>
        </a-col>
        <a-col :span="3" v-if="contrastInputStatus" class="select-box">
          <a-select
            show-search
            style="width: 120px"
            :not-found-content="null"
            @search="handleSearch"
            @inputKeydown.enter="
              () => {
                contrastInputStatus = false
              }
            "
          >
            <div slot="dropdownRender">
              <recycle-scroller
                class="virtual-list"
                :buffer="1000"
                :prerender="200"
                style="max-height: 200px"
                :item-size="32"
                key-field="period_id"
                :items="keyword"
              >
                <template v-slot="{ item, index }">
                  <div class="list-item" :key="index" @click="handleSelect(item.period_id)">
                    {{ item.name }}
                  </div>
                </template>
              </recycle-scroller>
            </div>
          </a-select>
          <a-icon
            class="select-del-icon"
            type="close-circle"
            @click="
              () => {
                contrastInputStatus = false
              }
            "
          />
        </a-col>
        <a-col :span="3">
          <div style="display: flex">
            <a-button @click="addContrast" style="margin-right: 10px">+ 添加对比</a-button>
            <a-button type="primary" @click="chaDate" icon="search">查询</a-button>
          </div>
        </a-col>
      </a-row>
      <!-- 图表区域 -->
      <a-row :gutter="[15, 15]" class="chart-border">
        <a-col :span="24">
          <LineChart
            :title="`${classTitlePrefix || gradeTitlePrefix || '全校'}【学生情绪变化趋势】`"
            height="250px"
            :fields="moodField"
            :dataSource="studentMood"
            showAvgBtn
          >
            <template slot="titleExtra">
              <div>
                <a-button
                  style="margin-right: 10px"
                  type="primary"
                  class="custom-btn"
                  @click="exportData(studentMood)"
                >
                  导出数据
                </a-button>
                <a-button type="primary" class="custom-btn" @click="addEventClick">
                  添加事件
                </a-button>
              </div>
            </template>
          </LineChart>
        </a-col>
        <!-- <a-col :span="8" :height="250">
          <Radar :dataSource="radarData" :fields="['学生模型']" />
        </a-col> -->
      </a-row>
    </a-card>
    <split-pane :min-percent="20" :default-percent="50" split="vertical">
      <template slot="paneL" v-if="!isShowPic">
        <a-card title="学生列表" :headStyle="{ fontSize: '16px', fontWeight: 'bold' }">
          <!--          <a slot="extra">-->
          <!--            <a-tooltip-->
          <!--              title="提醒逻辑：1.本期平均值 低于 往期平均值 * ( 1 - 阈值% )。2.计算逻辑：先取个人单日情绪值再取所有学生平均值。3.去除周期内超一半日期无抓拍数据学生，去除双休日法定节假日数据。4.时间跨度须以周为单位较为精准，周一开始，周日结束。"-->
          <!--            >-->
          <!--              <a-icon type="info-circle" style="cursor: pointer" />-->
          <!--            </a-tooltip>-->
          <!--          </a>-->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="24">
                <!-- <a-col :span="6">
                  <a-form-item label="情绪阈值">
                    <a-input-number v-model="queryParam.threshold" :min="0" :max="100" />
                  </a-form-item>
                </a-col> -->
                <a-col :span="6">
                  <a-form-item label="关爱名单" style="width: 100%">
                    <a-select
                      v-model="queryParam.careList"
                      placeholder="请选择关爱名单"
                      style="width: 170px; margin-right: 15px"
                      :options="careListOptions"
                      allowClear
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="标签" style="width: 100%">
                    <!-- <j-dict-select-tag
                      style="width: 100%"
                      placeholder="请选择标签"
                      v-model="formData.tagId"
                      dictCode="sys_dict_item,item_text,id,dict_id=1844644258892341249"
                    /> -->
                    <a-select
                      allowClear
                      show-search
                      placeholder="请选择标签"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                      @change="handleTagChange"
                    >
                      <a-select-option
                        v-for="item in stukeyword"
                        :key="item.value"
                        :value="item.value"
                      >
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-input-search
                    placeholder="请输入学生姓名"
                    v-model="queryParam.name"
                    style="width: 100%"
                    @change="searchName"
                  />
                </a-col>

                <a-col :span="4">
                  <span
                    style="float: left; overflow: hidden"
                    class="table-page-search-submitButtons"
                  >
                    <a-button type="primary" @click="getTableData" icon="search" :loading="loading">
                      查询
                    </a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>

          <!-- 操作按钮区域 -->
          <div class="table-operator">
            <!--            <a-button type="primary" icon="download" @click="chartToImg" :loading="loading">-->
            <!--              导出-->
            <!--            </a-button>-->
            <a-button v-has="'studentInfoExport:show'" type="primary" @click="chartToImg">
              导出
            </a-button>
          </div>

          <div>
            <a-table
              ref="table"
              size="middle"
              :scroll="dataSource.length ? { x: 900, y: 550 } : {}"
              bordered
              rowKey="id"
              :columns="columnsWithOutHidden"
              :dataSource="dataSource"
              :loading="loading"
              :pagination="pagination"
              class="j-table-force-nowrap"
              @change="handleTableChange"
            >
              <a
                slot="studentName"
                :style="text === currRowData.studentName ? 'color:red' : ''"
                slot-scope="text, record"
                @click="changeSelect(record)"
              >
                {{ text }}
              </a>
              <div slot="action" slot-scope="text, record" style="color: #1890ff; cursor: pointer">
                <span class="action-option" @click="showAddLabel(record)">+标签</span>
                <span class="action-option" @click="showLineDetail(record)">档案</span>
              </div>
            </a-table>
          </div>
        </a-card>
      </template>
      <template slot="paneR">
        <a-card title="学生心理情绪档案" :headStyle="{ fontSize: '16px', fontWeight: 'bold' }">
          <a-button type="primary" slot="extra" @click="derivedInfo">导出</a-button>
          <a-spin tip="加载中..." :spinning="chartLoading">
            <div class="outer-card">
              <div ref="exportContent">
                <StuLineMoodCard
                  v-for="(item, index) in studentLineArr"
                  :key="index"
                  :name="item.name"
                  :dataSource="item.dataSource"
                  :moodField="item.fileds"
                  :studentInfo="item.studentInfo"
                  @showImgDetail="showImgDetail(item.studentInfo)"
                  @addStuCompareData="addStuCompareData"
                  @deleteRecord="deleteRecord"
                />
              </div>
            </div>
          </a-spin>
        </a-card>
      </template>
    </split-pane>
    <AddEventModal ref="addEventModal" @refresh="refreshMarked" />
    <ImgTimeLineModal ref="imgTimeLineModal" />
    <ViewKeyPointModal ref="viewKeyPointModal" />
    <AddLabelModal ref="addLabelModal" />

    <div style="width: 600px" id="exportChart">
      <LineChart
        v-for="(item, index) in exportChartData"
        style="width: 600px; z-index: -9999"
        height="220px"
        :fields="item.fileds"
        :dataSource="item.dataSource"
      />
    </div>
  </div>
</template>

<script>
import splitPane from 'vue-splitpane'
import '@/assets/less/TableExpand.less'
import { getAction, postAction } from '@api/manage'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SmoothLineChartMultid from '@/components/chart/SmoothLineChartMultid'
import LineChart from '@/components/echartZyz/components/LineChart'
import moment from 'moment'
import { mapGetters } from 'vuex'
import UpdateStudentFaceModal from '../studentInfo/modules/UpdateStudentFaceModal'
import Radar from '@/components/chart/Radar'
import {
  addLineCompare,
  deleteLineCompare,
  exportToPdf,
  handleLineChartData,
  openNewTabPage,
  randomColor,
  simpleDebounce,
} from '@/utils/util'
import AddEventModal from '@/comUi/AddEventModal'
import ImgTimeLineModal from './components/ImgTimeLineModal'
import StuLineMoodCard from './components/StuLineMoodCard'
import ViewKeyPointModal from './components/ViewKeyPointModal'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css' // 引入它的 css
import { RecycleScroller } from 'vue-virtual-scroller'
import AddLabelModal from '@/comUi/AddLabelModal'
import html2canvas from 'html2canvas'
import * as XLSX from 'xlsx'
import Vue from 'vue'
import { IDENTITY_ID } from '@/store/mutation-types'

export default {
  name: 'StudentWarnGeneral',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    splitPane,
    SmoothLineChartMultid,
    LineChart,
    UpdateStudentFaceModal,
    Radar,
    AddEventModal,
    ImgTimeLineModal,
    StuLineMoodCard,
    ViewKeyPointModal,
    RecycleScroller,
    AddLabelModal,
  },
  data() {
    return {
      loading: false,
      formData: {},
      gradeTitlePrefix: '',
      classTitlePrefix: '',
      lineRangeData: [],
      queryParam: {
        // threshold: 40,
        // careList: 0,
      },
      disableMixinCreated: true,
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
          width: 100,
          ellipsis: true,
        },
        {
          title: '学生',
          align: 'center',
          dataIndex: 'studentName',
          scopedSlots: { customRender: 'studentName' },
        },
        {
          title: '情绪指数',
          align: 'center',
          children: [
            {
              title: '学生(本期)',
              align: 'center',
              dataIndex: 'personHappyRate',
            },
            {
              title: '学生(往期)',
              align: 'center',
              dataIndex: 'historyHappyRate',
            },
            {
              title: '班级(本期)',
              align: 'center',
              dataIndex: 'classHappyRate',
            },
            {
              title: '年级(本期)',
              align: 'center',
              dataIndex: 'gradeHappyRate',
            },
          ],
        },
        {
          title: '关爱名单',
          align: 'center',
          dataIndex: 'careList',
          filters: [
            { text: '须关爱', value: 1 },
            { text: '正常', value: 0 },
          ],
          onFilter: (value, record) => record.careList === value,
          customRender: function (t, r, index) {
            return t === 0 ? '否' : '是'
          },
        },
        // {
        //   title: '家长访问(次)',
        //   align: 'center',
        //   dataIndex: 'visitCnt',
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 100,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      columnsWithOutHidden: [],
      chartLoading: false,
      selfData: [],
      classData: [],
      gradeData: [],
      warnData: [],
      currRowData: {},
      isShowPic: false,
      rangeDate: [],
      picLoading: false,
      picData: [],
      //导出export使用
      exportChartData: [],
      url: {
        // list: '/statistic/studentWarn',
        list: '/statistic/studentMoodTrend',
        studentWarnAnalysis: '/statistic/studentWarnAnalysis',
        childWarnNumTrend: '/statistic/childWarnNumTrend',
        studentFaceList: '/aigoes/studentFace/list',
        exportXlsUrl: '/statistic/exportStudentMoodXls',
        getMoreStudentMoodData: '/statistic/getMoreStudentMoodData',
        uploadMoodDataImg: '/statistic/uploadMoodDataImg',
      },
      keyword: [],
      searchContextList: [],
      moodField: [],
      compareData: [],
      studentMood: [],
      loadingChart: false,
      contrastInputStatus: false,
      radarData: [
        { item: '认知能力', 学生模型: 80 },
        { item: '理工类专业匹配指数', 学生模型: 30 },
        { item: '人文类专业匹配指数', 学生模型: 60 },
        { item: '技术类专业匹配指数', 学生模型: 30 },
        { item: '非技术类专业匹配指数', 学生模型: 40 },
        { item: '亲子关系', 学生模型: 70 },
        { item: '心理健康风险', 学生模型: 10 },
        { item: '负面心态风险', 学生模型: 20 },
      ],
      searchItem: [],
      searchItemColor: [],
      timeType: 'last7days',
      dataType: 1,
      timeTypeOptions: [
        {
          label: '今天',
          value: 'today',
        },
        {
          label: '近七天',
          value: 'last7days',
        },
        {
          label: '近20天',
          value: 'last20days',
        },
        {
          label: '近40天',
          value: 'last40days',
        },
        {
          label: '近三个月',
          value: 'last3months',
        },
        {
          label: '近半年',
          value: 'last6months',
        },
      ],
      studentLineArr: [],
      careListOptions: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        // showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      stukeyword: [],
      userIdentity: Vue.ls.get(IDENTITY_ID),
    }
  },
  created() {
    this.columnsWithOutHidden = this.columns.filter((item) => !item.hidden)
    const dateInterval = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    const beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    const endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.lineRangeData = dateInterval
    this.$set(this.formData, 'beginDate', beginDate)
    this.$set(this.formData, 'endDate', endDate)
    this.getUserIdentityClassOrGrade()
  },
  watch: {
    'formData.gradeId': function (val) {
      this.getStudentMood()
      this.getTableData()
      this.getSearchKeyword()
      if (!val) {
        this.gradeTitlePrefix = ''
      }
    },
    'formData.classId': function (val) {
      this.getStudentMood()
      this.getTableData()
      this.getSearchKeyword()
      if (!val) {
        this.classTitlePrefix = ''
      }
    },
  },
  methods: {
    ...mapGetters(['userInfo']),
    searchName: simpleDebounce(function (event) {
      this.$set(this.pagination, 'current', 1)
      this.getTableData()
    }, 500),
    handleTableChange(page) {
      this.pagination = page
      this.getTableData()
    },
    async getUserIdentityClassOrGrade() {
      const res = await getAction('/statistic/getUserIdentityClassOrGrade', {
        userIdentity: this.userIdentity,
      })
      const { success, result } = res
      if (!success) {
        this.$message.warn(res.message)
        return
      }
      // 校长、心理老师直接请求
      if (this.userIdentity == 1 || this.userIdentity == 6) {
        this.getStudentMood()
        this.getTableData()
        this.getSearchKeyword()
      } else {
        // 年级组长、老师设置对应的id
        result.gradeId && this.$set(this.formData, 'gradeId', result.gradeId)
        result.classId && this.$set(this.formData, 'classId', result.classId)
        this.gradeTitlePrefix = result.gradeName
        this.classTitlePrefix = result.className
      }
    },
    getTableData() {
      this.loading = true
      let paramsData = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.queryParam,
        ...this.formData,
        careList: this.queryParam.careList,
      }
      getAction(this.url.list, paramsData)
        .then((res) => {
          if (res.success) {
            this.dataSource = res.result.records
            this.$set(this.pagination, 'total', res.result.total)
            if (res.result.records.length > 0) {
              this.currRowData = res.result.records[0]
              // 覆盖图表
              this.pushStuIdArr = []
              this.loadChartData(0)
            } else {
              this.studentLineArr = []
            }
          }
          if (res.code === 500) {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeSelect(record) {
      console.log('选择学生记录：', record)
      this.currRowData = record
      // 叠加图表
      this.loadChartData(1)
    },
    loadChartData(type) {
      const isHasStu = this.studentLineArr.some(
        (item) => item.studentInfo.studentId == this.currRowData.studentId
      )
      if (type == 1 && isHasStu) {
        this.$message.warning('该学生已添加过，请勿重复添加')
        return
      }
      this.chartLoading = true
      const paramsData = {
        studentId: this.currRowData.studentId,
        // type: this.timeType,
        dataType: this.dataType,
        beginDate: this.formData.beginDate,
        endDate: this.formData.endDate,
      }

      getAction(this.url.childWarnNumTrend, paramsData).then((res) => {
        if (res.success) {
          const { lineData, filedList } = handleLineChartData(res.result)
          // const filterFileds = filedList.filter((item) => item != this.currRowData.studentName)
          const filterList = res.result.filter((item) => item.name === this.currRowData.studentName)
          const lastPointObj = filterList[filterList.length - 1]
          const stuObj = {
            name: this.currRowData.studentName,
            fileds: [...filedList],
            dataSource: lineData,
            studentInfo: {
              ...this.queryParam,
              beginDate: this.formData.beginDate,
              endDate: this.formData.endDate,
              studentId: this.currRowData.studentId,
              id: this.currRowData.studentId,
              name: this.currRowData.studentName,
              aiExplain: lastPointObj.aiExplain,
            },
          }
          if (type == 0) {
            this.studentLineArr = [stuObj]
          } else {
            this.studentLineArr.unshift(stuObj)
          }
        }
        this.chartLoading = false
      })
    },

    onRangeChange(dates, dateString) {
      this.lineRangeData = dates
      this.$set(this.formData, 'beginDate', dateString[0])
      this.$set(this.formData, 'endDate', dateString[1])
      this.getStudentMood()
      this.getTableData()
      this.getSearchKeyword()
    },
    addContrast() {
      this.context2 = ''
      this.contrastInputStatus = true
    },
    getSearchKeyword() {
      getAction('/statistic/getKeyword', {
        ...this.queryParam,
        gradeId: this.formData.gradeId,
        classId: this.formData.classId,
        beginDate: this.formData.beginDate,
        endDate: this.formData.endDate,
      }).then((res) => {
        if (res.success) {
          this.searchContextList = res.result
          this.keyword = res.result
        }
      })
    },
    handleSearch: simpleDebounce(function (value) {
      this.queryParam.con = value || ''
      if (!this.searchContextList.length) {
        this.getSearchKeyword()
      } else {
        this.keyword = value
          ? this.searchContextList.filter((item) => item.name.includes(value))
          : this.searchContextList
      }
    }, 300),
    handleChange(value) {
      this.context2 = value
      let index = this.keyword.findIndex((i) => i.period_id == value)
      let name = this.keyword[index].name
      console.log(value, name)
      this.formData.crux = name
      this.formData.id = value
    },
    async handleSelect(value) {
      let currItem = this.keyword.find((i) => i.period_id == value)
      console.log('currItem--', currItem)

      this.$set(this.formData, 'crux', currItem.name)
      this.$set(this.formData, 'id', value)
      // 重置关键词
      this.keyword = this.searchContextList
      if (value) {
        const isHasData = await this.getCompareData(undefined, currItem.dataType)
        if (!isHasData) {
          this.$message.warn('当前标签分类为空')
          return
        }
        if (!this.searchItem.includes(this.formData.crux)) {
          this.searchItem.push(this.formData.crux)
          this.searchItemColor.push(randomColor())
        }
      }
      this.contrastInputStatus = false
    },
    // 添加对比数据
    async getCompareData(currStuInfo, dataType) {
      const params = currStuInfo
        ? {
            id: currStuInfo.id,
            crux: currStuInfo.name,
            beginDate: currStuInfo.beginDate,
            endDate: currStuInfo.endDate,
            dataType: dataType == undefined ? 1 : dataType,
          }
        : { ...this.formData, dataType: dataType == undefined ? 1 : dataType }

      this.loadingChart = true
      const res = await getAction('/statistic/compareData', params)
      this.loadingChart = false
      if (res.success) {
        this.compareData = res.result
        const { lineData, filedList } = addLineCompare(
          this.studentMood,
          this.moodField,
          this.compareData
        )
        this.studentMood = lineData
        this.moodField = filedList
        return !!res.result?.length
      }
      return false
    },
    filterLineField(obj, field) {
      const keys = Object.keys(obj)
      if (!keys.length) return []
      const filterKeys = keys.filter((item) => !field.includes(item))
      return filterKeys
    },
    selectTag(type, record) {
      console.log('选择标签', record, type)
      switch (type) {
        case 'grade':
          this.$set(this.formData, 'classId', undefined)
          this.$set(this.formData, 'gradeId', record.value)
          this.gradeTitlePrefix = record.text
          break
        case 'class':
          this.$set(this.formData, 'classId', record.value)
          this.classTitlePrefix = record.text
          break
      }
      // this.$set(this.formData, 'name', record.text)
    },
    // 折线图数据
    getStudentMood() {
      const paramsData = { beginDate: this.formData.beginDate, endDate: this.formData.endDate }
      if (this.formData.classId) {
        paramsData.classId = this.formData.classId
      } else if (this.formData.gradeId) {
        paramsData.gradeId = this.formData.gradeId
      }
      this.loadingChart = true

      getAction('/statistic/schoolMoodTrend', paramsData)
        .then((res) => {
          if (res.success) {
            const { lineData, filedList } = handleLineChartData(res.result)
            this.studentMood = lineData
            this.moodField = filedList
          }
        })
        .finally(() => {
          this.loadingChart = false
        })
    },
    // 添加事件
    addEventClick() {
      console.log('添加事件信息：', this.studentMood, this.moodField)

      this.$refs.addEventModal.show(this.studentMood, this.moodField)
    },
    // 刷新标注
    refreshMarked(record) {
      const porintIndex = this.studentMood.findIndex(
        (item) => item[record.filed + 'id'] == record.id && item.type == record.type
      )
      if (porintIndex != -1) {
        const incident = record.filed + 'incident'
        this.$set(this.studentMood[porintIndex], incident, record['incident'])
        console.log('刷新标注后的数据：', this.studentMood)
      }
    },
    // 查询
    chaDate() {
      this.searchItem = []
      this.getStudentMood()
      this.$set(this.pagination, 'current', 1)
      this.getTableData()
    },
    deleteBtn(item) {
      const lineData = deleteLineCompare(this.studentMood, item)
      const idx_s = this.searchItem.indexOf(item)
      if (idx == -1) return
      const idx = this.moodField.indexOf(item)
      this.moodField.splice(idx, 1)
      this.searchItem.splice(idx_s, 1)
      this.searchItemColor.splice(idx_s, 1)
      this.studentMood = lineData
    },
    // 查看照片详情
    showImgDetail(dataInfo) {
      this.$refs.imgTimeLineModal.show(dataInfo)
    },
    // 学生折线图信息导出
    derivedInfo() {
      const element = this.$refs.exportContent
      exportToPdf(element, '学生心理情绪档案')
    },
    // 列表查看详情
    showLineDetail(record) {
      // console.log('行信息--', record)
      // this.$refs.viewKeyPointModal.show({ id: record.studentId, name: record.studentName }, 2)
      openNewTabPage({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId || record.student_id,
          pagePath: '/school/statistic/StudentWarnGeneral',
        },
      })
    },
    showAddLabel(record) {
      const recordData = {
        studentId: record.studentId,
        // keyword: record.studentName,
        beginDate: this.formData.beginDate,
        endDate: this.formData.endDate,
      }
      this.$refs.addLabelModal.show(recordData)
    },
    // 添加学生对比
    addStuCompareData(currStuInfo) {
      if (!this.searchItem.includes(currStuInfo.name)) {
        this.searchItem.push(currStuInfo.name)
        this.searchItemColor.push(randomColor())
      }
      this.getCompareData(currStuInfo)
    },
    deleteRecord(currStuInfo) {
      const index = this.studentLineArr.findIndex((item) => item.studentInfo.id == currStuInfo.id)
      if (index != -1) {
        this.studentLineArr.splice(index, 1)
        this.$message.success('删除卡片成功')
      } else {
        this.$message.warning('记录不存在，删除失败')
      }
    },
    handleTagChange(value) {
      console.log('选择的标签', value)
      this.queryParam.tagId = value
    },
    getStudentKeyword() {
      getAction('/statistic/getKeyword', {
        dataType: '3',
      }).then((res) => {
        if (res.success) {
          this.stukeyword = res.result.map((item) => ({
            label: item.name,
            value: item.period_id,
          }))
        }
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    /**
     * 导出excel携带情绪曲线
     */
    chartToImg() {
      var that = this
      that.exportChartData = []

      that.$confirm({
        title: '提示',
        content: '本次操作将会导出本页所有学生+情绪曲线，确定导出吗?',
        onOk() {
          that.loading = true
          var hide = that.$message.loading('正在获取学生情绪数据...', 0)

          var studentIds = []
          var classIds = []
          var gradeIds = []
          for (var i = 0; i < that.dataSource.length; i++) {
            studentIds.push(that.dataSource[i].studentId)
            classIds.push(that.dataSource[i].classId)
            gradeIds.push(that.dataSource[i].gradeId)
          }
          that.queryParam.beginDate = that.formData.beginDate
          that.queryParam.endDate = that.formData.endDate
          that.queryParam.studentTags = that.queryParam.tagId
          that.queryParam.gradeId = that.formData.gradeId
          that.queryParam.classId = that.formData.classId
          postAction(that.url.getMoreStudentMoodData, {
            studentIds: studentIds,
            classIds: classIds,
            gradeIds: gradeIds,
            beginDate: that.formData.beginDate,
            endDate: that.formData.endDate,
          }).then((res) => {
            if (res.success) {
              res.result.forEach((item) => {
                // 本次请求唯一标识
                that.queryParam.key = item.key
                const { lineData, filedList } = handleLineChartData(item.data)
                const stuObj = {
                  id: item.unionId,
                  fileds: filedList,
                  dataSource: lineData,
                }
                that.exportChartData.push(stuObj)
              })
              setTimeout(hide, 0)

              setTimeout(function () {
                that.$message.loading('正在生成学生情绪曲线...', 2)
                const element = window.document.getElementById('exportChart')
                if (element) {
                  // 多次调用html2canvas会导致浏览器内存溢出，采用图片分片模式
                  html2canvas(element, {
                    scale: 1, // 设定为 1，避免 DPI 引起的尺寸翻倍
                  }).then((canvas) => {
                    // 创建切片
                    for (let i = 0; i < that.exportChartData.length; i++) {
                      let sliceCanvas = document.createElement('canvas')
                      let sliceCtx = sliceCanvas.getContext('2d')
                      sliceCanvas.width = 600
                      sliceCanvas.height = 220

                      // 将当前切片绘制到新 canvas 上
                      sliceCtx.drawImage(canvas, 0, 220 * i, 600, 220, 0, 0, 600, 220)

                      // 上传截图
                      postAction(that.url.uploadMoodDataImg, {
                        unionId: that.exportChartData[i].id,
                        b64: sliceCanvas.toDataURL('image/png'),
                      })
                    }

                    canvas = null
                  })
                }

                setTimeout(function () {
                  that.$message.loading('正在生成excel...', 5)
                  that.handleExportXls('学生情绪数据分析')
                  that.loading = false
                }, 5000)
              }, 2000)
            }
          })
        },
      })
    },
    exportData(data) {
      console.log('导出的数据--', data)
      var exportData = []
      data.forEach((column) => {
        var singleData = {}
        for (let key in column) {
          if (key.indexOf('id') < 0 && key.indexOf('incident') < 0 && key.indexOf('warn') < 0) {
            singleData[key] = column[key]
          }
        }
        exportData.push(singleData)
      })
      console.log('导出的数据--', exportData)

      // 将数据转化为xlsx的表格数据结构
      const ws = XLSX.utils.json_to_sheet(exportData)

      // 新建工作簿并添加表格数据
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '学生情绪变化趋势')

      // 生成Excel文件并导出
      XLSX.writeFile(wb, '学生情绪变化趋势.xlsx')
    },
  },
}
</script>
<style scoped lang="less">
@import '~@assets/less/common.less';
// ::v-deep {
//   .ant-select {
//     width: 100% !important;
//   }
// }
.chart-border {
  min-height: 300px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 10px;
  margin: 20px 2px !important;
}

.custom-btn {
  background-color: #ffffff;
  color: #1890ff;
  border-color: #1890ff;
  text-shadow: none;
  box-shadow: none;
}

.delete-icon {
  cursor: pointer;
  background-color: #c8b9bc;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  right: -6px;
}

.tag-col {
  animation: tagAppear 0.3s linear;
}

.select-box {
  position: relative;
  animation: tagAppear 0.3s linear;
}

@keyframes tagAppear {
  from {
    transform: translate(20px, -20px) scale(0.4);
    opacity: 0;
  }
  to {
    transform: translate(0, 0) scale(1);
    opacity: 1;
  }
}

.tag-item {
  width: 100% !important;
  box-sizing: border-box;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 2px;
  height: 30px;
  line-height: 30px;
  padding-left: 5px;

  .text {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.select-del-icon {
  cursor: pointer;
  background-color: #c8b9bc;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -1px;
  right: 3px;
}

.title {
  font-size: 15px;
  font-weight: bold;
  margin-right: 12px;
}

.outer-card {
  min-height: 400px;
  max-height: 850px;
  overflow-y: auto;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;
  }
}

.card-box {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  margin: 10px;
}

.line-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.row-box {
  display: flex !important;
  flex-wrap: wrap !important;
}

::v-deep {
  .ant-select {
    width: 100% !important;
  }
}

.virtual-list {
  // y轴滚动
  overflow-y: auto;
  // 隐藏x轴滚动条
  overflow-x: hidden;
}

.list-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 32px;
  padding-left: 10px;
  cursor: pointer;
}

.list-item:hover {
  background-color: #e6f7ff;
}

.action-option {
  padding: 0 4px;
}
</style>
